import { Controller } from "@hotwired/stimulus"

// Il modulo del preventivo di una voce (RiepilogoVoci di components/rendicontazione/RigheVoci.js, 31a5bd1).
// leggi: cambiato il documento, le proposte del programma si chiedono al server (frame «preventivo-proposte-…»);
// nessun documento = nessuna proposta. usa: una proposta riempie fornitore e P.IVA. chiudi: il frame torna chiuso.
export default class extends Controller {
  static targets = ["documento", "proposte", "fornitore", "piva"]
  static values = { proposta: String, chiudi: String }

  leggi() {
    const id = this.documentoTarget.value
    const frame = this.proposteTarget
    frame.removeAttribute("src")
    frame.replaceChildren()
    if (!id) return
    frame.src = `${this.propostaValue}?documento_id=${encodeURIComponent(id)}`
  }

  usa({ params: { fornitore, piva } }) {
    this.fornitoreTarget.value = fornitore
    this.pivaTarget.value = piva
  }

  chiudi() {
    const frame = this.element.closest("turbo-frame")
    if (frame) frame.src = this.chiudiValue
  }
}
